<template>
  <!-- 头部 start -->
  <div class="header">
    <div class="header-box">
      <img class="logo" src="../../static/home/logo.png">
      <div class="right">
        <div @click="tab(0)" :class="tabIndex == 0?'active':''" class="tabList ">
          <span>Home</span>
        </div>
        <div @click="tab(1)" :class="tabIndex == 1?'active':''" class="tabList">
          <span>About</span>
        </div>
        <div @click="tab(2)" :class="tabIndex == 2?'active':''" class="tabList">
          <span>Contact Us</span>
        </div>
      </div>
      <img class="right-min" @click="drawer = true" src="../../static/home/header-dian.png">
    </div>
    <el-drawer size="75%" title="Close Menu" custom-class="custom-class" :modal-append-to-body="false"
      :visible.sync="drawer" :direction="direction">
      <div class="tabList" @click="tab(0)">
        <span>Home</span>
      </div>
      <div class="tabList" @click="tab(1)">
        <span>About Us</span>
      </div>
      <div class="tabList" @click="tab(2)">
        <span>Contact US</span>
      </div>
      <div class="tabList-icon">
        <img @click="open(1)" src="../../static/home/fff2.png">
        <img @click="open(2)" src="../../static/home/fff.png">
        <img @click="open(3)" src="../../static/home/fff1.png">
      </div>
    </el-drawer>
  </div>
  <!-- 头部 end -->

</template>

<script>
  export default {
    props: {
      tabIndex: {
        type: [String, Number]
      }
    },
    data() {
      return {
        drawer: false,
        direction: 'ltr'
      }
    },
    methods: {
      // 打开新网页
      open(n) {
        if (n == 1) {
          window.open('http://www.instagram.com/', '_blank');
        } else if (n == 2) {
          window.open('http://www.facebook.com/', '_blank');
        } else if (n == 3) {
          window.open('http://twitter.com/', '_blank');
        }
      },
      // 切换tab
      tab(n) {
        this.drawer = false;
        if (n == 0) {
          this.$router.push({
            path: '/'
          })
        } else if (n == 1) {
          this.$router.push({
            path: '/About'
          })
        } else if (n == 2) {
          this.$router.push({
            path: '/ContactUs'
          })
        }
      }
    }
  }
</script>

<style scoped>
  .header {
    font-size: 12px;
  }

  @media only screen and (min-width:1200px) {
    .header {
      width: 100%;
      height: 90px;
      position: sticky;
      top: 0;
      z-index: 120;
      background: #FFFFFF;
      border-bottom: #EEEEEE solid 1px;
    }

    .header-box {
      width: 1200px;
      height: 90px;
      opacity: 1;
      justify-content: space-between;
      display: flex;
      align-items: center;
      margin: 0 auto;

    }

    .logo {
      width: 180px;
      height: 46px;
      display: block;
    }

    .tabList {
      user-select: none;
      padding: 0 10px;
      height: 90px;
      display: flex;
      align-items: center;
      margin-left: 66px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 28px;
      color: #666666;
      opacity: 1;
      cursor: pointer;
    }

    .tabList:hover {
      background-color: #EEEEEE;
    }

    .tabList span {
      white-space: nowrap;
      font-size: 14px;
    }

    .active {
      border-bottom: #0282CA 2px solid;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      color: #333333;
      opacity: 1;
    }

    .right-min {
      display: none;
    }

    .right {
      display: flex;
    }
  }

  @media only screen and (min-width:768px) and (max-width: 1199px) {
    .header {
      width: 100%;
      height: 90px;
      position: sticky;
      top: 0;
      z-index: 120;
      border-bottom: #EEEEEE solid 1px;
      background: #FFFFFF;
    }

    .header-box {
      width: 768px;
      height: 90px;
      background: #FFFFFF;
      opacity: 1;
      justify-content: space-between;
      display: flex;
      align-items: center;
      margin: 0 auto;

    }

    .logo {
      width: 180px;
      height: 46px;
      display: block;
    }

    .tabList {
      user-select: none;
      padding: 0 10px;
      height: 90px;
      display: flex;
      align-items: center;
      margin-left: 66px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 28px;
      color: #666666;
      opacity: 1;
      cursor: pointer;
    }

    .tabList:hover {
      background-color: #EEEEEE;
    }

    .tabList span {
      white-space: nowrap;
    }

    .active {
      border-bottom: #0282CA 2px solid;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      color: #333333;
      opacity: 1;
    }

    .right-min {
      display: none;
    }

    .right {
      display: flex;
    }
  }

  @media only screen and (max-width: 768px) {
    .header {
      width: 100%;
      height: 1.18rem;
      position: sticky;
      top: 0;
      z-index: 120;
      background: #E7EFF7;
    }

    .header-box {
      width: 100%;
      height: 1.18rem;
      opacity: 1;
      justify-content: space-between;
      display: flex;
      align-items: center;
      margin: 0 auto;

    }

    .logo {
      width: 1.80rem;
      height: 0.46rem;
      display: block;
      margin-left: 0.32rem;
    }

    .tabList {
      user-select: none;
      padding: 0 0.1rem;
      height: 1.09rem;
      display: flex;
      align-items: center;
      margin-left: 0.4rem;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 28px;
      color: #333333;
      opacity: 1;
      cursor: pointer;
      border-bottom: #EEEEEE solid 1px;
      margin-right: 0.4rem;
    }

    .tabList-icon {
      position: absolute;
      bottom: 0.3rem;
      margin-left: 0.24rem;
    }

    .tabList-icon img {
      width: 0.88rem;
      height: 0.88rem;
      margin-right: 0.2rem;
    }

    .tabList:hover {
      background-color: #EEEEEE;
    }

    .tabList span {
      white-space: nowrap;
    }

    .active {
      border-bottom: #0282CA 2px solid;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      color: #333333;
      opacity: 1;
    }

    .right-min {
      width: 0.40rem;
      height: 0.16rem;
      margin-right: 0.32rem;
    }

    .right {
      display: none;
    }

    .header>>>.el-drawer__header {
      font-size: 0.32rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue